import React from 'react'
import { InputNumber, InputNumberProps } from 'antd'
import styled from '@emotion/styled'

interface TextFieldNumberProps extends InputNumberProps {
  id?: string
  min?: number
  step?: number | string
  value?: number | null
  autoFocus?: boolean
  addonAfter?: string
  onChange?: (value: any) => void
  spinner?: string
  inputType?: 'number' | undefined
  disabled?: boolean
  precision?: number
}

const TextFieldNumber = (props: TextFieldNumberProps) => {
  const Component = props.inputType === 'number' ? InputNumber : FullWidthInputNumber
  return (
    <div
      className={`text-field-number-input ant-input-group ${
        props.inputType === 'number' ? '-number' : ''
      }`}
    >
      <Component {...props} defaultValue={props.defaultValue} />
      {props.addonAfter && (
        <span className='ant-input-group-addon text-field-number-addon'>
          {props.addonAfter}
        </span>
      )}
    </div>
  )
}

const FullWidthInputNumber = styled(InputNumber)`
  width: 100%;
`

export default TextFieldNumber
